<template>
  <div>
    <p>
      {{title}}
      <br />
      <small>{{subtitle}}</small>
    </p>

    <p v-bind:key="r" v-for="(r,index) in Math.floor(timeSlots.length/cols)">
      <md-chip
        md-clickable
        class="md-secondary"
        v-bind:key="timeSlots[index*cols+index2]"
        v-for="(col, index2) in cols"
        @click="selectTime(timeSlots[index*cols+index2])"
        :class="{'md-accent': selectedTime==timeSlots[index*cols+index2]}"
      >{{timeSlots[index*cols+index2]}}</md-chip>
    </p>
  </div>
</template>

<script>
export default {
  name: "TimeSlot",
  props: {
    interval: {
      type: Number,
      required: false,
      default: 15,
    },
    from: {
      type: Number,
      required: false,
      default: 9,
    },
    to: {
      type: Number,
      required: false,
      default: 18,
    },
    cols: {
      type: Number,
      required: false,
      default: 4,
    },
    title: {
      type: String,
      required: false,
      default: "Available time slots for your appointment",
    },
    subtitle: {
      type: String,
      required: false,
      default: "",
    },
    skip: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data: function () {
    return {
      selectedTime: null,
    };
  },
  methods: {
    selectTime: function (time) {
      this.selectedTime = time;

      this.$emit("click", time);
    },
  },
  computed: {
    timeSlots: function () {
      var minutes = (this.to - this.from) * 60;
      var slots = [];
      var toSkip = this.skip;
      for (var i = 0; i <= minutes; i += this.interval) {
        if (i == 0) {
          let prependStr = this.from < 10 ? "0" : "";
          if (toSkip <= 0) {
            slots.push(prependStr + this.from + ":00");
          } else toSkip--; //skipping
        } else if (i == minutes) slots.push(this.to + ":00");
        else if (toSkip <= 0) {
          slots.push(
            (this.from + Math.floor(i / 60) < 10 ? "0" : "") +
              (this.from + Math.floor(i / 60)) +
              ":" +
              (i % 60 == 0 ? "00" : i % 60)
          );
        } else toSkip--; //skipping
      }

      return slots;
    },
  },
};
</script>

<style scoped>
</style>
